import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { UserDetailsComponent } from '../../../../components/admin-dashboard-component/user-management/user-details-component/user-details-component';
import { AuthService } from '../../../../services/auth-service';
import { Loading } from '../../../../utils/loading/loading';
import { UserDetailsVTO } from '../../../../services/auth-service.model';

@Component({
  selector: 'app-view-user-details',
  imports: [CommonModule, UserDetailsComponent, Loading],
  templateUrl: './view-user-details.html',
  styleUrl: './view-user-details.scss',
})
export class ViewUserDetails implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);

  userData = signal<UserDetailsVTO | null>(null);
  pageLoading = signal<boolean>(true);
  pageError = signal<string | null>(null);

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.loadUser(parseInt(id));
      }
    });
  }

  loadUser(id: number) {
    this.pageLoading.set(true);
    this.pageError.set(null);

    this.authService
      .getUserById(id)
      .pipe(finalize(() => this.pageLoading.set(false)))
      .subscribe({
        next: (data) => {
          this.userData.set(data as unknown as UserDetailsVTO);
        },
        error: (err) => {
          this.pageError.set(err?.messageEn || 'Failed to load user.');
        },
      });
  }
}